import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Checkbox from "@mui/material/Checkbox";

import {cartItemInterface} from "../../shoppingCart/cartItemInterface";
import {changeAllCartItems} from "../../../actions/shoppingCartFunctions";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";


const LookListMainFeatureCheckbox = (props) => {

  const {cartItem, changeAllCartItems, isRemoved, cartItems} = props;

  if (cartItem.relatedProductParent) {
    return null
  }

  const checkboxClick = () => {
    const featureLabel = Analytics.getSkuForAnalytics(cartItem.cartFeature);
    Analytics.sendClickEvent(`${LOOK_JOURNEY_ANALYTIC_EVENTS.lookListCartItemSelect + featureLabel}-${isRemoved ? "check" : "uncheck"}`);

    const newCartItems = [...cartItems.map(cItem => {
      if ((cItem.cartFeature.dbFeature.id === cartItem.cartFeature.dbFeature.id)
        || (cItem.relatedProductParent && (cItem.relatedProductParent.dbFeature.id === cartItem.cartFeature.dbFeature.id))) {
        cItem.isRemoved = !isRemoved
      }
      return cItem
    })];
    changeAllCartItems(newCartItems);
  }

  return <Checkbox className="ll-feature__checkbox" checked={!isRemoved} onChange={checkboxClick} />
};

LookListMainFeatureCheckbox.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface).isRequired
}

const mapStateToProps = (store, ownProps) => {
  const {cartItems} = store.cartState;
  return {
    isRemoved: ownProps.cartItem.isRemoved,
    cartItems,
  };
};

const mapDispatchToProps = {
  changeAllCartItems
};

export default connect(mapStateToProps, mapDispatchToProps)(LookListMainFeatureCheckbox)
